import ApiService from '../api.service';
const moduleName = 'docs';

const DocumentsService = {
    getDocumentList: async function(itemsPerPage, currentItem, iWhereOrderLocale) {
        try {
            let response = await ApiService.post(moduleName + '/getDocuments', { itemsPerPage, currentItem, iWhereOrderLocale });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getUserContractsList: async function(icontract_rid) {
        try {
            let response = await ApiService.get(moduleName + '/getUserContractsList', {
                params: {
                    icontract_rid
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getUserObjectContractsList: async function(icontract_rid) {
        try {
            let response = await ApiService.get(moduleName + '/getUserObjectContractsList', {
                params: {
                    icontract_rid
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getKSKHousesList: async function(iksk_rid) {
        try {
            let response = await ApiService.get(moduleName + '/getKSKHousesList', {
                params: {
                    iksk_rid
                }
            });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getRefAhsDocTypes: async function() {
        try {
            let response = await ApiService.get(moduleName + '/getRefAhsDocTypes');
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    postDoc: async function(nvcDocumentsData) {
        try {
            let response = await ApiService.post(moduleName + '/postDoc', { nvcDocumentsData });
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    attachmentsTempInsert: async function(data) {
        try {
            let response = await ApiService.post(moduleName + '/attachmentsTempInsert', data);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    },
    getFile: async function(iAhsDocument_rid) {
        try {
            let response = await ApiService.get(moduleName + '/getFile', {
                params: {
                    iAhsDocument_rid: iAhsDocument_rid
                }
            });
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getAttachment: async function(iAttachmentLinkRid) {
        try {
            let response = await ApiService.get(moduleName + '/getAttachment?iAttachmentLinkRid=' + iAttachmentLinkRid);
            return response.data.data;
        } catch (e) {
            console.error(e);
        }
    },
    getSignedDocument: async guid => {
        try {
            let response = await ApiService.get(`${moduleName}/getSignedDocument?guid=${guid}`);
            return response.data;
        } catch (e) {
            console.error(e);
        }
    }
};

export default DocumentsService;
